import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useTenantSchema = () => {
  const { t } = useTranslation();

  const tenantSchema = z.object({
    name: z.string()
      .nonempty({ message: t("errors.requiredField", { fieldName: t("superAdmin.tenant.tenantName") }) })
      .min(2, { message: t("errors.fieldMin", { fieldName: t("superAdmin.tenant.tenantName") }) }).max(32, { message: t("errors.fieldMax", { fieldName: t("superAdmin.tenant.tenantName") }) }),
  })
  return { tenantSchema }
}